(function (ng) {
    ng.module('evo.Shared.Directives').directive('productImage', ['PRODUCT_IMAGE_ROOT',
        function (PRODUCT_IMAGE_ROOT) {
            return {
                link: function ($scope) {
                    $scope.buildImagePath = function () {
                        var relativePath = $scope.image || '_notavailable.jpg';
                        return PRODUCT_IMAGE_ROOT + relativePath;
                    };
                },
                replace: true,
                restrict: 'E',
                scope: {
                    alt: '@',
                    image: '=',
                    product: '=',
                    title: '@'
                },
                template: '<img alt="{{ alt }}" ng-src="{{ buildImagePath() }}" title="{{ title }}" />'
            };
        }
    ]);
})(angular);